import * as Yup from 'yup';
import { TType } from '@translations/translationsTypes';

export const freedomOfInformationFormValidationScheme = (t: TType) => {
  return Yup.object()
    .shape({
      title: Yup.string()
        .min(3, t('global.error.invalidInput'))
        .max(100, t('global.error.invalidInput'))
        .required(t('global.error.required')),
      email: Yup.string()
        .matches(
          /^(?!.*\.\.)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          t('global.error.email')
        )
        .max(40, t('global.error.email'))
        .required(t('global.error.required')),
      phoneNumber: Yup.string()
        .min(10, t('global.error.globalPhone.min'))
        .max(15, t('global.error.globalPhone.max'))
        .matches(/^\d+$/, t('global.error.invalidInput'))
        .required(t('global.error.required')),
      firstName: Yup.string()
        .min(3, t('global.error.invalidInput'))
        .max(100, t('global.error.invalidInput'))
        .required(t('global.error.required')),
      lastName: Yup.string()
        .min(3, t('global.error.invalidInput'))
        .max(100, t('global.error.invalidInput'))
        .required(t('global.error.required')),
      description: Yup.string()
        .min(3, t('global.error.invalidInput'))
        .max(400, t('global.error.invalidInput'))
        .required(t('global.error.required')),
      purposeOfRequest: Yup.string()
        .min(3, t('global.error.invalidInput'))
        .max(100, t('global.error.invalidInput'))
        .required(t('global.error.required')),
      recaptchaToken: Yup.string().required(t('global.error.required')),
    })
    .nullable();
};
